const initialState = {
  visible: null,
  payload: null,
  loading: null,
  reference_id: null,
  data: null,
};

export default initialState;
